import { createSlice } from '@reduxjs/toolkit';

const initialState = { bookedUntilDate: '', isBookedDialogOpen: false };

const bookedDialogSlice = createSlice({
  name: 'bookedDialog',
  initialState,
  reducers: {
    openBookedDialog(state, { payload }) {
      state.bookedUntilDate = payload.bookedUntilDate;
      state.isBookedDialogOpen = true;
    },
    closeBookedDialog(state) {
      state.isBookedDialogOpen = false;
    }
  }
});

export const { openBookedDialog, closeBookedDialog } = bookedDialogSlice.actions;

export default bookedDialogSlice.reducer;
